import Image from '../../Components/Image'
import { Resolution } from '../../Controllers/ResolutionController'
import Config from '../Config'
import GameSceneContainer from '../GameSceneContainer/GameSceneContainer'

class InventoryItemsDetailsBox {
    element = document.querySelector('#details-box') as HTMLDivElement
    imgContainer = this.element.querySelector('#details') as HTMLDivElement

    constructor() {
        this.hide()
        this.element.onclick = this.hide
    }

    show = () => {
        this.element.classList.remove('hidden')
        // centralize
        // TODO: is there a css-only way?
        this.imgContainer.scrollTop = Config.resolution.resolution === Resolution.large ? 108 : 252
        this.imgContainer.scrollLeft = Config.resolution.resolution === Resolution.large ? 192 : 448

        GameSceneContainer.addClassName('details-box-open')
    }

    hide = () => {
        this.element.classList.add('hidden')
        GameSceneContainer.removeClassName('details-box-open')
    }

    setImage = (image: Image) => {
        if (this.imgContainer.firstChild) {
            this.imgContainer.replaceChild(image.element, this.imgContainer.firstChild)
        } else {
            this.imgContainer.appendChild(image.element)
        }
    }
}

export default new InventoryItemsDetailsBox()
